import { appURLs } from "@/app/constants.mjs";

/**
 * A hash function to map a 32 digit hexadecimal number to a decimal number between 0...29 using String.charCodeAt().
 * Sums up all the char codes of the digits. This gives a number between 1536 and 3264.
 * It then sums the digits in the char code sum. This gives a number between 0 and 29.
 * In case the given id is not a 32 digit hexadecimal, it falls back to giving a random number between 0 and 29.
 *
 * @param id
 */
function getKeyFromId(id = "") {
  let sumOfCharacters = 0;
  for (let i = 0; i < id.length; i++) {
    sumOfCharacters += id.charCodeAt(0);
  }
  let result = 0;
  let next = sumOfCharacters;
  while (next > 0) {
    result = result + (next % 10);
    next = (next / 10) | 0;
  }

  if (!id || result > 29) return Math.floor(Math.random() * 29);

  return result;
}
export default {
  getWeaponImage: (weaponId: string): string => {
    // TODO
    return weaponId;
  },
  getRankIcon: (key: string) => {
    return `${appURLs.CDN}/fortnite/ranks/${key}.webp`;
  },
  getProfileImage: (id: string, characterId?: string) => {
    if (characterId) {
      return `${appURLs.CDN}/fortnite/images/with-background/${characterId.toLowerCase()}.webp`;
    }
    const key = getKeyFromId(id);
    return `${appURLs.CDN}/fortnite/avatars/${key}.webp`;
  },
};
